import { asyncAction } from 'lib/action';

export const getDocumentMessagingHistory = asyncAction('REQUEST/AN/GET_DOCUMENT_MESSAGE_HISTORY');
export const sendMessageAction = asyncAction('REQUEST/AN/SEND_MESSAGE');

export const getTransactionMessagingHistory = asyncAction('REQUEST/GET_TRANSACTION_MESSAGE_HISTORY');
